import { a as CHECKBOX_VARIANT } from '../prop-types-cc01d273.js';

var defaultProps = {
  hasError: false,
  readOnly: false,
  disabled: false,
  checked: false,
  onChange: function onChange() {
    return null;
  },
  variant: CHECKBOX_VARIANT.DEFAULT,
  children: null,
  containerProps: {},
  name: ''
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
